import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Film, Home, Search } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 5 saniye sonra otomatik ana sayfaya yönlendir
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-950 text-white flex flex-col">
      <Helmet>
        <title>Sayfa Bulunamadı - Cinefora</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <Header />
      
      <main className="flex-grow flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full text-center space-y-8">
          {/* 404 Icon */}
          <div className="relative">
            <div className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500">
              404
            </div>
            <Film className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 text-gray-800 opacity-30" />
          </div>

          {/* Message */}
          <div className="space-y-4">
            <h1 className="text-3xl md:text-4xl font-bold text-white">
              Aradığınız Sayfa Bulunamadı
            </h1>
            <p className="text-gray-400 text-lg">
              Üzgünüz! Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.
            </p>
            <p className="text-gray-500 text-sm">
              5 saniye içinde otomatik olarak ana sayfaya yönlendirileceksiniz...
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-black font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Home className="w-5 h-5" />
              Ana Sayfaya Dön
            </button>
            
            <button
              onClick={() => navigate('/vizyondaki-filmler')}
              className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 border border-gray-700"
            >
              <Search className="w-5 h-5" />
              Filmlere Göz At
            </button>
          </div>

          {/* Popular Links */}
          <div className="pt-8 border-t border-gray-800">
            <p className="text-gray-500 text-sm mb-4">Popüler Sayfalar:</p>
            <div className="flex flex-wrap justify-center gap-3">
              <button
                onClick={() => navigate('/vizyondaki-filmler')}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm transition-colors"
              >
                Vizyondaki Filmler
              </button>
              <button
                onClick={() => navigate('/yakinda')}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm transition-colors"
              >
                Yakında
              </button>
              <button
                onClick={() => navigate('/salonlarimiz')}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm transition-colors"
              >
                Salonlarımız
              </button>
              <button
                onClick={() => navigate('/iletisim')}
                className="px-4 py-2 bg-gray-800 hover:bg-gray-700 rounded-lg text-sm transition-colors"
              >
                İletişim
              </button>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
